// noinspection ES6UnusedImports
import React, {useEffect, useState} from 'react';
import ItemSelection from './ItemSelection.jsx';
import ItemOptionSelection from './ItemOptionSelection.jsx';
import StyleSelection from './StyleSelection.jsx';
import OrderHint from '../OrderHint.jsx';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from '../message-list';

export default function Selection({texts, product, hideOrderHint}) {
    const [currentStyle, setCurrentStyle] = useState(product.currentStyle);
    const [currentItem, setCurrentItem] = useState(product.currentItem);
    const [currentItemOption, setCurrentItemOption] = useState(product.currentItemOption);

    useEffect(() => {
        const subscription = MessageBroker.subscribe(ProductMessages.CHANGED, ({item, itemOption, style}) => {
            if (item !== undefined) {
                setCurrentItem(item);
            }
            if (style !== undefined) {
                setCurrentStyle(style);
            }
            if (itemOption !== undefined) {
                setCurrentItemOption(itemOption);
            }
        });

        return () => MessageBroker.unsubscribe(subscription);
    }, []);

    const determineOrderHint = (item, itemOption) => {
        if (hideOrderHint) {
            return null;
        }

        if (itemOption) {
            return itemOption.orderHint;
        }

        return item.orderHint;
    };

    const orderHint = determineOrderHint(currentItem, currentItemOption);

    return (
        <>
            <ItemSelection
                texts={texts}
                product={product}
                currentItem={currentItem}
                currentItemOption={currentItemOption}
                currentStyle={currentStyle}
            />
            {!product.coliCount && product.displaySizes && (
                <ItemOptionSelection
                    texts={texts}
                    product={product}
                    currentItem={currentItem}
                    currentItemOption={currentItemOption}
                />
            )}
            {product.hasStyles && (
                <StyleSelection
                    texts={texts}
                    product={product}
                    currentItem={currentItem}
                    currentItemOption={currentItemOption}
                    currentStyle={currentStyle}
                />
            )}
            {orderHint && <OrderHint product={product} hint={orderHint}/>}
        </>
    );
}
